import React, { useState } from 'react';
import "./Patient.css";

const PatientDetails = ({ patientDetails, loadPatientByUhid }) => { 
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="accordion" id="patientDetailsAccordion">
            <div className="accordion-item">
                <h2 className="accordion-header d-flex justify-content-between align-items-center" id="headingOne">
                    <div className="d-flex align-items-center w-100">
                        <button
                            className={`accordion-button ${isOpen ? '' : 'collapsed'} flex-grow-1`}
                            type="button"
                            onClick={() => setIsOpen(!isOpen)}
                            aria-expanded={isOpen}
                            aria-controls="collapseOne"
                        >
                            <div className="row g-1 d-flex justify-content-between w-100">
                                <div className="col-md-6 d-flex align-items-center">
                                    <strong className={`me-2 ${isOpen ? 'w130' : ''}`}>Name:</strong>
                                    <span>{patientDetails.name || '-'}</span>
                                </div>
                                <div className="col-md-6 d-flex align-items-center">
                                    <strong className={`me-2 ${isOpen ? 'w130' : ''}`}>Mobile No:</strong>
                                    <span>{patientDetails.mobileNo ?? '-'}</span>
                                </div>
                            </div>
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm ms-2"
                            style={{ fontSize: '20px' }}
                            title="Reload"
                            onClick={() => {
                                const uhid = localStorage.getItem('uhid');
                                if (uhid && loadPatientByUhid) {
                                    loadPatientByUhid(uhid);
                                }
                            }}
                        >
                            🔄
                        </button>
                    </div>
                </h2>

                <div
                    id="collapseOne"
                    className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
                    aria-labelledby="headingOne"
                    data-bs-parent="#patientDetailsAccordion"
                >
                    <div className="accordion-body">
                        <div className="row g-1">
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Patient ID:</strong>
                                <span>{patientDetails.code || '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Age:</strong>
                                <span>{patientDetails.age ?? '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Gender:</strong>
                                <span>{patientDetails.gender || '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Email:</strong>
                                <span>{patientDetails.emailId || '-'}</span>
                            </div>
                            <div className="col-md-12 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Aadhar:</strong>
                                <span>{patientDetails.aadharNo || '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Address:</strong>
                                <span>{patientDetails.address || '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Pincode:</strong>
                                <span>{patientDetails.pincode || '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Blood Group:</strong>
                                <span>{patientDetails.bloodGroup || '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>BMI:</strong>
                                <span>{patientDetails.bmi ?? '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Height (cm):</strong>
                                <span>{patientDetails.height ?? '-'}</span>
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <strong className="me-2" style={{ width: '130px' }}>Weight (kg):</strong>
                                <span>{patientDetails.weight ?? '-'}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatientDetails;
